const _excluded = ["dashboardData"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PieChart from '../components/PieChart';
import DashCard from '../components/DashCard';
const ClaimStatePieChart = _ref => {
  let {
      dashboardData
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const labels = ['Total Projects', 'R&D Projects'];
  const seriesvisitors = [dashboardData.total_project_count || 0, dashboardData.system_project_count];
  return /*#__PURE__*/React.createElement(DashCard, _extends({}, props, {
    title: "R&D Projects v Total Projects",
    className: "h-100"
  }), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: seriesvisitors,
    label: 'Total Projects'
  }));
};
export default ClaimStatePieChart;